import svc from 'svc';



let interval = null;

export const types = {
	GET_NOTIFICATIONS: 'NOTIFICATIONS/GET_NOTIFICATIONS',
	GET_NOTIFICATIONS_PENDING: 'NOTIFICATIONS/GET_NOTIFICATIONS_PENDING',
	GET_NOTIFICATIONS_FULFILLED: 'NOTIFICATIONS/GET_NOTIFICATIONS_FULFILLED',
	GET_NOTIFICATIONS_REJECTED: 'NOTIFICATIONS/GET_NOTIFICATIONS_REJECTED',
};

export const initialState = [];

export default ( state = initialState, action ) => {
	switch (action.type) {
		case types.GET_NOTIFICATIONS:
			return state;
		case types.GET_NOTIFICATIONS_PENDING:
			return state;
		case types.GET_NOTIFICATIONS_FULFILLED:
			return action.payload.payload.data;
		case types.GET_NOTIFICATIONS_REJECTED:
			return state;
		default:
			return state;
	}
}

export const actions = {
	refresh: () => {
		return ( dispatch, getState ) => {
			let uid = getState().appData.UserID;
			if ( !uid ) {
				return false;
			}

			dispatch( { type: types.GET_NOTIFICATIONS_PENDING } );

			svc.send( 'activity', { method: 'listByAssigned', userID: uid } ).then( res => {
				dispatch( { type: types.GET_NOTIFICATIONS_FULFILLED, payload: res } );

				if ( interval === null ) {
					interval = setInterval( () => {
						actions.refresh()( dispatch, getState );
					}, 180000 ); // 3 minutes
				}
			} ).catch( err => {
				dispatch( { type: types.GET_NOTIFICATIONS_REJECTED } );
			} );
		};
	},
};